import { atom } from 'jotai';
import type { LandXMLCategory, LandXMLFeatureMetadata } from '@/core/landxml';

/**
 * Snapshot of a clicked LandXML feature, exposed to the properties drawer.
 * `clickPoint` is the world-space hit position so the drawer can derive
 * station-along-alignment for ALIGNMENT picks.
 */
export interface SelectedLandXMLFeature {
  layerId: string;
  /** `${category}:${name}:${ordinal}` — stable across reloads of the same file. */
  featureId: string;
  name: string;
  category: LandXMLCategory;
  metadata: LandXMLFeatureMetadata;
  /** World-space hit position. */
  clickPoint?: { x: number; y: number; z: number };
  /**
   * Closest registered alignment (any layer) for non-alignment picks —
   * answers "where on the road is this point?". `station` is an internal
   * station on the alignment identified by `key`.
   */
  nearestAlignment?: {
    key: string;
    name: string;
    station: number;
    offset: number;
    dz: number;
  };
}

export const selectedLandXMLFeatureAtom = atom<SelectedLandXMLFeature | null>(null);
